const Layout = () => import('@/views/Layout.vue')

const Index = () => import('@/views/LongBreakIndex.vue')
const List = () => import('@/views/LongBreakList.vue')
const Detail = () => import('@/views/GymnasticsDetail.vue')
const DetailInfo = () => import('@/views/GymnasticsDetailInfo.vue')
const DetailStat = () => import('@/views/GymnasticsDetailStat.vue')
const Edit = () => import('@/views/LongBreakEdit.vue')

import menuIcon from '@/assets/images/icon_menu_long_break@2x.png'
import menuIconActive from '@/assets/images/icon_menu_long_break_active@2x.png'
import { Route } from 'vue-router'

export default [
  {
    path: '/long-break',
    name: 'long_break',
    component: Layout,
    meta: {
      title: '特色大课间',
      icon: menuIcon,
      iconActive: menuIconActive,
      showMenu: true,
    },
    children: [
      {
        path: 'index',
        name: 'long_break_index',
        component: Index,
        meta: {
          title: '大课间活动',
          showMenu: true,
        },
      },
      {
        path: 'list',
        name: 'long_break_list',
        component: List,
        meta: {
          title: '大课间回家练',
          showMenu: true,
        },
      },
      {
        path: 'edit',
        name: 'long_break_edit',
        component: Edit,
        props: (route: Route) => ({ ...route.query }),
        meta: {
          title: '大课间活动',
        },
      },
      {
        path: 'detail',
        name: 'long_break_detail',
        component: Detail,
        meta: { title: '大课间回家练', showMenu: false },
        children: [
          {
            path: 'stat',
            name: 'long_break_detail_stat',
            component: DetailStat,
            props: (route: Route) => ({ id: route.query.id }),
            meta: { title: '大课间回家练' },
          },
          {
            path: 'info',
            name: 'long_break_detail_info',
            component: DetailInfo,
            props: (route: Route) => ({ id: route.query.id }),
            meta: { title: '大课间回家练' },
          },
        ],
      },
    ],
  },
]
